import { render } from "./BaseFormElement.vue?vue&type=template&id=5d2d8167"
import script from "./BaseFormElement.vue?vue&type=script&lang=js"
export * from "./BaseFormElement.vue?vue&type=script&lang=js"
script.render = render

export default script